import { 
    SET_LOADING,
    SET_LIST_TYPE,
    SET_SHOWCASE_ARTISTS_LIST,
    SET_SHOWCASE_ARTISTS_LIST_META,
    APPEND_SHOWCASE_ARTISTS_LIST,
    SET_FAVORITE_DIRECTORS_LIST,
    SET_FAVORITE_DIRECTORS_LIST_META,
    APPEND_FAVORITE_DIRECTORS_LIST,
    SET_SELECTED_DIRECTOR,
    SET_SELECTED_DIRECTOR_META,
    SET_USER_IMAGES,
    SET_ACTIVE_AUDITION_LIST,
    SET_ACTIVE_AUDITION_LIST_META,
    SET_PAST_AUDITION_LIST,
    SET_PAST_AUDITION_LIST_META,
    APPEND_ACTIVE_AUDITION_LIST,
    APPEND_PAST_AUDITION_LIST,
} from "../../actions/user/types";

const INITIAL_STATE = {
    loading: false,
    showcaseArtistList: [],
    showcaseArtistListMetaData: {
        loading: false, hasMore: true
    },
    favoriteDirectorList: [],
    favoriteDirectorListMetaData: {
        loading: false, hasMore: true
    },
    listType: 'grid',
    selectedDirector: null,
    selectedDirectorMeta: null,
    userImageList: [],
    activeAuditionsList: [],
    activeAuditionsListMetaData: {
        loading: false, hasMore: true
    },
    pastAuditionsList: [],
    pastAuditionsListMetaData: {
        loading: false, hasMore: true
    },
}

const UserReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_SHOWCASE_ARTISTS_LIST: {
            return {
                ...state,
                showcaseArtistList: action.payload
            }
        }
        case SET_SHOWCASE_ARTISTS_LIST_META: {
            return {
                ...state,
                showcaseArtistListMetaData: action.payload
            }
        }
        case APPEND_SHOWCASE_ARTISTS_LIST: {
            return {
                ...state,
                showcaseArtistList: [ ...state.showcaseArtistList, ...action.payload]
            }
        }
        case SET_FAVORITE_DIRECTORS_LIST: {
            return {
                ...state,
                favoriteDirectorList: action.payload
            }
        }
        case SET_FAVORITE_DIRECTORS_LIST_META: {
            return {
                ...state,
                favoriteDirectorListMetaData: action.payload
            }
        }
        case APPEND_FAVORITE_DIRECTORS_LIST: {
            return {
                ...state,
                favoriteDirectorList: [ ...state.favoriteDirectorList, ...action.payload]
            }
        }
        case SET_SELECTED_DIRECTOR: {
            return {
                ...state,
                selectedDirector: action.payload
            }
        }
        case SET_SELECTED_DIRECTOR_META: {
            return {
                ...state,
                selectedDirectorMeta: action.payload
            }
        }
        case SET_LIST_TYPE: {
            return {
                ...state,
                listType: action.payload
            }
        }
        case SET_USER_IMAGES: {
            return {
                ...state,
                userImageList: action.payload
            }
        }
        case SET_ACTIVE_AUDITION_LIST: {
            return {
                ...state,
                activeAuditionsList: action.payload
            }
        }
        case SET_ACTIVE_AUDITION_LIST_META: {
            return {
                ...state,
                activeAuditionsListMetaData: action.payload
            }
        }
        case APPEND_ACTIVE_AUDITION_LIST: {
            return {
                ...state,
                activeAuditionsList: [ ...state.activeAuditionsList, ...action.payload]
            }
        }
        case SET_PAST_AUDITION_LIST: {
            return {
                ...state,
                pastAuditionsList: action.payload
            }
        }
        case SET_PAST_AUDITION_LIST_META: {
            return {
                ...state,
                pastAuditionsListMetaData: action.payload
            }
        }
        case APPEND_PAST_AUDITION_LIST: {
            return {
                ...state,
                pastAuditionsList: [ ...state.pastAuditionsList, ...action.payload]
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default UserReducer;